import React from "react";

import { Box, Heading, SimpleGrid, Text } from "@chakra-ui/react";

import { IntegrationCard } from "@/components/features/settings/IntegrationCard";
import { commsPlatforms } from "@/util/helpers";

export interface CompanyPractiseConnectionsProps {}

export const CompanyPractiseConnections: React.FC<
  CompanyPractiseConnectionsProps
> = () => (
  <Box mt={8} rounded={16} px={10} py={10} bg="white">
    <Box>
      <Heading fontSize={16} mb={4} fontWeight={600}>
        Connections
      </Heading>
      <Text fontSize={14}>Connect your favourite third party apps</Text>
    </Box>

    <Box mt={14}>
      <Text fontWeight={600} mb={4}>
        Communication
      </Text>

      <SimpleGrid spacing={17} columns={[1, 1, 2, 2, 3, 4]}>
        {Object.keys(commsPlatforms).map((key) => {
          const platform = commsPlatforms[key];
          if (!platform.forCompanies) return null;
          return <IntegrationCard key={key} platform={platform} />;
        })}
      </SimpleGrid>
    </Box>
  </Box>
);
